<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="white"></help-link>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1 mt-5">
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search name" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <b>{{cutOffPeriod}}</b>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?headers_timesheet_mobile:headers_timesheet"
                    :items="attendance_corrections_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable">
                            <td>
                                <v-chip class="user-chip-container">
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    <b>{{props.item.firstName}} {{props.item.lastName}}</b>
                                </v-chip>
                            </td>
                            <td>
                                <span v-if="isMobile">{{ props.item.transDate | moment('MMM D') }}</span>
                                <span v-else>{{ props.item.transDate | moment('YYYY-MM-DD (ddd)') }}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.clockIn | moment('hh:mm a') }}</td>
                            <td v-if="!isMobile">{{ props.item.clockOut | moment('hh:mm a') }}</td>
                            <td v-if="!isMobile">{{ props.item.totalHours }}</td>
                            <td v-if="!isMobile">{{ props.item.chargeableHours }}</td>                                                
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>  
</template>

<script>

import attCorrectionsApi from '@/api/attendancecorrection'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getCutoffCoverageDescription } from '@/helpers/cutoff-format'

export default {     
    name: 'AttendanceCorrections',
    metaInfo: {
        title: 'Attendance Corrections',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Attendance Corrections' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            serverDate: null,
            headers_timesheet: [
                {text: 'Employee',align: 'left',value: 'lastName', width:'15%', sortable:true},
                {text: 'Date',align: 'left',value: 'transDate', width:'15%', sortable:true},
                {text: 'Clock-In',align: 'left',value: 'clockIn', width:'10%',sortable:true},
                {text: 'Clock-Out',align: 'left',value: 'clockOut', width:'10%',sortable:true},
                {text: 'Total Hours',align: 'left',value: 'totalHours', width:'10%',sortable:true},
                {text: 'Chargeable Hours',align: 'left',value: 'chargeableHours', width:'10%',sortable:true}, 
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
            headers_timesheet_mobile: [
                {text: 'Employee',align: 'left', value:'lastName', width:'50%', sortable:true},
                {text: 'Date', align: 'left',value: 'transDate', width:'20%', sortable:true},
                {text: 'Status',align: 'left', value:'status', width:'20%', sortable:true},
            ],
            cutoff_details: null,
            attendance_corrections: [],
        }
    },
    methods: {  
        viewDetails(data) {
            this.$router.push(`/${this.accessedFrom}/corrections/details/${data.attendanceCorrectionsId}`)
        }, 
        async getAttendanceCorrectionsByTeam() {
            try {
                this.loading = true
                const response = await attCorrectionsApi.getByCutoffByCompany(this.selectedCutOffId)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.attendance_corrections = response.data.items
                }
                this.loading = false
            }catch(error){
                this.loading = false
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Company Attendance Corrections'
        })

        this.getAttendanceCorrectionsByTeam()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 800
        },
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details)
                return getCutoffCoverageDescription(this.cutoff_details.cutoffStart, this.cutoff_details.cutoffEnd)
        },
        attendance_corrections_filtered() {
            var temp = this.attendance_corrections

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.firstName.toLowerCase().includes(this.search.toLowerCase()) || item.lastName.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
            return temp
        },
        accessedFrom() {
            return 'company'
        },
        helpPageId() {
            return 'attendance-corrections-review-company'
        },
        frozenPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        }
    }
}
</script>